import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Store } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const decodedToken = this.store.selectSnapshot(AuthState.getDecodedToken);
    const tenant = this.store.selectSnapshot(AuthState.getTenant);
    const headers = decodedToken.token !== '' ? req.headers.append('Authorization', 'bearer ' + decodedToken.token).append('TenantId', tenant.id) : req.headers;

    const authReq = req.clone({
      headers
    });

    return next.handle(authReq);
  }
}
